import styled from "styled-components";

export const StyleAvatar = styled.img`
  max-width: 100%;
  border-radius: 50%;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    width: 128px;
  }
`;
